"use client";
import React from "react";
export default function ThreeColShape(props) {
    var _props_col;
    return /*#__PURE__*/ React.createElement("div", {
        className: "pb-2 md:py-20 lg:pt-24 lg:pb-44 relative pt-11 overflow-hidden bg-gray-30 white-triangle white-triangle-left"
    }, /*#__PURE__*/ React.createElement("div", {
        className: 'relative px-6 md:px-14 before:lg:content-[""] before:lg:block before:lg:w-1/2 before:lg:h-2 before:lg:absolute before:lg:bottom-0 before:lg:right-0 before:lg:border-b-2 before:lg:border-b-[#D0ECEF]'
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mx-auto max-w-4xl relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "mb-4 md:mb-12 lg:mb-20"
    }, /*#__PURE__*/ React.createElement("h2", {
        className: "mx-auto mb-3 text-center font-medium max-w-xs md:max-w-md lg:max-w-lg block text-2xl md:text-3xl lg:text-4xl"
    }, props.heading), props.description ? /*#__PURE__*/ React.createElement("p", {
        className: "mb-4 md:mb-8 lg:text-lg xl:text-xl text-center mx-auto max-w-xl lg:max-w-3xl"
    }, props.description) : null), /*#__PURE__*/ React.createElement("div", {
        className: "relative"
    }, /*#__PURE__*/ React.createElement("div", {
        className: 'flex flex-col before:lg:content-[""] before:lg:block before:w-0.5 before:bg-[#D0ECEF] before:absolute before:-bottom-[192px] before:-left-[119px] before:h-20 after:lg:content-[""] after:lg:block after:lg:w-[165px] after:lg:h-0.5 after:lg:bg-[#D0ECEF] after:lg:origin-left after:lg:-rotate-[44deg] after:lg:absolute after:lg:-bottom-[114px] after:lg:-left-[118px]'
    }, /*#__PURE__*/ React.createElement("ul", {
        className: 'md:flex md:gap-x-8 w-full relative max-[767px]:order-last mt-4 md:mt-2 before:lg:content-[""] before:lg:block before:lg:w-full before:lg:h-2 before:lg:absolute before:lg:bottom-0 before:lg:left-0 before:lg:border-b-2 before:lg:border-b-[#D0ECEF]'
    }, (_props_col = props.col) === null || _props_col === void 0 ? void 0 : _props_col.map(function(col, index) {
        /*#__PURE__*/ return React.createElement("li", {
            key: index,
            className: "border-b-4 border-b-blue-500 pb-4 md:pb-6 relative md:flex-1 mb-9 md:m-0 z-10"
        }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("img", {
            height: "36",
            src: "".concat(col === null || col === void 0 ? void 0 : col.iconUrl),
            alt: "".concat(col === null || col === void 0 ? void 0 : col.title),
            loading: "lazy",
            className: "w-6 md:w-9 md:h-9 mb-3 md:mb-4"
        }), /*#__PURE__*/ React.createElement("span", {
            className: "lg:text-xl"
        }, col === null || col === void 0 ? void 0 : col.title)));
    })))))));
}
